var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        "max-width": "300",
        "retain-focus": false,
        persistent: "",
        "hide-overlay": "",
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _vm.calciatore_id
        ? _c(
            "v-card",
            { staticClass: "navy pa-4" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "navy white--text pt-2 px-2 d-flex align-center font-hemi-head",
                },
                [
                  _c("span", { staticStyle: { "font-size": "18px" } }, [
                    _vm._v("Scegli slot per..."),
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { depressed: "", icon: "" },
                      on: {
                        click: function ($event) {
                          return _vm.dismiss()
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("calciatore", {
                staticClass: "mt-4",
                attrs: {
                  id: _vm.calciatore_id,
                  cal: _vm.calciatoreComprato,
                  borderAsRuolo: "",
                  hideEditRemove: "",
                  small: "",
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "pa-4 white--text text-center" }, [
                _c("div", [
                  _vm._v(
                    "\n        Hai acquistato " +
                      _vm._s(_vm.nomeCalciatore) +
                      " ma non era tra i\n        "
                  ),
                  _c("span", {}, [_vm._v('"pianificati"')]),
                  _vm._v(".\n      "),
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "\n        Scegli in quale slot inserirlo tra quelli ancora liberi qui sotto:\n      "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                [
                  !_vm.areSlotsEnough
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "pa-4 navy darken-3 error--text text-center",
                        },
                        [
                          _c("v-icon", { staticClass: "error--text" }, [
                            _vm._v("warning"),
                          ]),
                          _vm._v(
                            "\n        Attenzione! Non ci sono slot disponibili per\n        " +
                              _vm._s(_vm.nomeCalciatore) +
                              " perchè hai acquistato più\n        " +
                              _vm._s(_vm.ruolo_plurale) +
                              " rispetto a quelli pianificati: aumenta il numero\n        di " +
                              _vm._s(_vm.ruolo_plurale) +
                              " pianificati nelle impostazioni della\n        pianificazione"
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "ml-1 error--text",
                              attrs: { "x-small": "", icon: "", outlined: "" },
                              on: { click: _vm.promptDialogPlanSettings },
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "error--text",
                                  attrs: { "x-small": "" },
                                },
                                [_vm._v("settings")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _c(
                        "v-list",
                        {
                          staticClass: "recycle-scroller",
                          class: { "nice-scroll": !_vm.is_mobile },
                        },
                        _vm._l(
                          _vm.myPlan[_vm.ruolo_abc],
                          function (slotData, slot, i) {
                            return _c("asta-slot", {
                              key: _vm.ruolo_abc + "_" + slot,
                              attrs: {
                                ruolo_abc: _vm.ruolo_abc,
                                iSlot: slot,
                                i: i,
                                onlyAssociaSlot: "",
                                overrideAssociaClick: _vm.associaSlot,
                              },
                            })
                          }
                        ),
                        1
                      ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }